// SafetyRequirementsLanding.tsx
import React, { useMemo } from "react";
import { Tabs } from "@shared/ui/tabs";
import { Shield, AlertTriangle, HardHat } from "lucide-react";

// Import the individual tab components
import SafetyPackagesTab from "./SafetyPackagesTab";
import SafetyProtocolsTab from "./SafetyProtocolsTab";
import PPEEquipmentTab from "./PPEEquipmentTab";

const SafetyRequirementsLanding: React.FC = () => {
  // Create tab components using the tabComponents pattern
  const tabComponents = useMemo(() => {
    return {
      ppe: {
        label: "PPE Equipment",
        shortLabel: "PPE",
        icon: <HardHat className="h-4 w-4" />,
        component: <PPEEquipmentTab />,
      },
      protocols: {
        label: "Safety Protocols",
        shortLabel: "Protocols",
        icon: <AlertTriangle className="h-4 w-4" />,
        component: <SafetyProtocolsTab />,
      },
      packages: {
        label: "Safety Packages",
        shortLabel: "Packages",
        icon: <Shield className="h-4 w-4" />,
        component: <SafetyPackagesTab />,
      },
    };
  }, []);

  return (
    <div className="space-y-6">
      {/* Safety Requirements Header */}
      <div className="mb-6">
        <h3 className="page-subheading">
          Safety Requirements
        </h3>
        <p className="page-subtitle">
          Configure safety packages, protocols, and PPE equipment for work
          orders
        </p>
      </div>

      <Tabs
        defaultValue="packages"
        className="w-full space-y-6"
        urlMapping={{
          packages: "packages",
          protocols: "protocols",
          ppe: "ppe",
        }}
        idPrefix="safety-requirements"
        tabComponents={tabComponents}
        tabsListClassName="grid w-full grid-cols-3 bg-gray-50 p-1 rounded-lg shadow-sm"
        level={1}
      />
    </div>
  );
};

export default SafetyRequirementsLanding;
